import type { BackfillFailedExecutionsJobs } from '../../types/backfill.types';

interface BackfillModalErrorTableProps {
  failedExecutions: BackfillFailedExecutionsJobs[];
}

const BackfillModalErrorTable: React.FC<BackfillModalErrorTableProps> = ({
  failedExecutions,
}) => {
  return (
    <table className="min-w-full divide-y divide-gray-200 border rounded-md">
      <thead>
        <tr className="bg-gray-50">
          <th className="px-4 py-2 text-left">Start Time</th>
          <th className="px-4 py-2 text-left">End Time</th>
          <th className="px-4 py-2 text-left">Error Message</th>
        </tr>
      </thead>
      <tbody>
        {failedExecutions.map((failed, idx) => (
          <tr key={idx}>
            <td className="px-4 py-2">{failed.startTime}</td>
            <td className="px-4 py-2">{failed.endTime}</td>
            <td className="px-4 py-2 text-red-600 break-all">
              {failed.errorMessage}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default BackfillModalErrorTable;
